export const DEV = 'dev'
export const STABLE = 'stable'
export const PROD = 'app'
export const ENV = DEV

export const CBM_APP_VERSION = '105'

export const ENV_SUBDOMAIN = ENV === PROD ? '' : `${ENV}.`
export const API_BASE_URL = `https://${ENV_SUBDOMAIN}api.comebackmobility.com/api/v1`